import { GetUserInfo } from '../service/home'
export default (_this, pageUrl, type) => {
    console.log(pageUrl, 'pageUrl')
    MgtvApi.getUseToken(
        {
            appId: 'FULU'
        },
        function (resp) {
            if (resp && resp.code == 200) {
                const token = resp.data.token
                _this.token = resp.data.token
                console.log('-----token', token)
                localStorage.setItem('token', token)
                _this.isOutIn = true

                // 有token，就去获取大使用户信息
                GetUserInfo().then((res) => {
                    const { code, data, message } = res
                    if (code == '0') {
                        _this.userInfo = data
                        localStorage.setItem('nickName', data.nickName)
                        localStorage.setItem('avatarUrl', data.avatarUrl)
                        localStorage.setItem('channelCode', data.channelCode)
                        localStorage.setItem('mgUuid', data.mgUuid)
                        localStorage.setItem('id', data.id)
                        localStorage.setItem('shareId', data.shareId)
                        localStorage.setItem('superiorId', data.superiorId)
                        localStorage.setItem('userLevel', data.userLevel)
                        localStorage.setItem('isDisable', 0)
                        _this.isAuthorized = true // 是否授权初始化用户信息
                        let publicUrl = process.env.NODE_ENV == 'development' ? 'http://test.mgtv.com/tpl/mclub' : 'https://lego.mgtv.com/tpl/mclub'
                        let typeParams = type ? `&type=${type}` : ''
                        // 分享
                        MgtvApi.showShareMenus(
                            {
                                title: '成为M-CLUB推广大使，稳赚不赔！',
                                desc: '招募芒果“合伙人”，月入过万，虚位以待！',
                                shareUrl: `${publicUrl}/#/${pageUrl}?nickName=${encodeURIComponent(
                                    data.nickName
                                )}&shareId=${data.id}` + typeParams,
                                /* shareUrl: process.env.NODE_ENV == 'development'
                                  ? `http://test.mgtv.com/tpl/mclub/#/${pageUrl}?nickName=${encodeURIComponent(
                                    data.nickName
                                  )}&shareId=${data.id}`
                                  : `https://lego.mgtv.com/tpl/mclub/#/${pageUrl}?nickName=${encodeURIComponent(
                                    data.nickName
                                  )}&shareId=${data.id}`, */
                                shareIcon:
                                    'https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/01d5ea84b7b24d37ad2e9d2f503828da.png'
                            },
                            function (resp) {
                                console.log('resp', resp)
                            }
                        )
                    } else if (code == '402') {
                        _this.isVisible = true
                        _this.userInfo = data
                        _this.isAuthorized = false // 是否授权初始化用户信息
                    } else if (code == '-1' && message == '账号已被禁用') {
                        _this.isDisable = true
                        _this.userInfo = data
                        localStorage.setItem('nickName', data.nickName)
                        localStorage.setItem('avatarUrl', data.avatarUrl)
                        localStorage.setItem('channelCode', data.channelCode)
                        localStorage.setItem('mgUuid', data.mgUuid)
                        localStorage.setItem('id', data.id)
                        localStorage.setItem('shareId', data.shareId)
                        localStorage.setItem('superiorId', data.superiorId)
                        localStorage.setItem('userLevel', data.userLevel)
                        localStorage.setItem('isDisable', 1)
                        _this.isAuthorized = true // 是否授权初始化用户信息
                        _this.$toast(message)
                    }
                })

                setTimeout(() => {
                    _this.init()
                }, 400)
            } else {
                console.log('err')
                localStorage.removeItem('token')
            }
        }
    )
    if (!_this.isOutIn) {
        localStorage.removeItem('token')
        // console.log('---KKKK')
        _this.init()
    }
}